import { render, staticRenderFns } from "./default.vue?vue&type=template&id=31b53df1"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HcmHeader: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/node_modules/@hotmart-org-ca/cosmos-mkt/components/_Sections_/HcmHeader/HcmHeader.vue').default,HotBreadcrumbList: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/BreadcrumbList/BreadcrumbList.vue').default,HotContainer: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default,HcmFooter: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/node_modules/@hotmart-org-ca/cosmos-mkt/components/_Sections_/HcmFooter/HcmFooter.vue').default})
